// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Divider,
  Button,
  // TableContainer,
  // Paper,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";
import MDButton from "theme/components/MDButton";
import DataFormSubmissionCard from "app/components/data_submission";

function OpsActivityLogPage() {
  const pageTitle = "Activity Log";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [activityLog, setActivityLog] = useState(null);
  const [currency, setCurrency] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/ops/activities/logs/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            console.log(result.data.data.log);
            setActivityLog(result.data.data.log);
            setCurrency(result.data.data.currency);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);


  function singularize(word) {
    if (!word || typeof word !== "string") return word;

    const irregular = {
      people: "person",
      men: "man",
      women: "woman",
      children: "child",
      teeth: "tooth",
      feet: "foot",
      mice: "mouse",
      geese: "goose",
      data: "datum",
      indices: "index",
      analyses: "analysis",
      crises: "crisis",
      diagnoses: "diagnosis",
      theses: "thesis",
      lives: "life",
      wives: "wife",
      knives: "knife",
      leaves: "leaf",
      shelves: "shelf",
      wolves: "wolf",
    };

    const lower = word.toLowerCase();

    if (irregular[lower]) {
      return matchCase(word, irregular[lower]);
    }

    if (lower.endsWith("ies") && lower.length > 3) {
      return matchCase(word, lower.slice(0, -3) + "y");
    }

    if (/(xes|zes|ches|shes|sses)$/.test(lower)) {
      return matchCase(word, lower.slice(0, -2));
    }

    if (lower.endsWith("ves")) {
      return matchCase(word, lower.slice(0, -3) + "f");
    }

    if (lower.endsWith("s") && !lower.endsWith("ss")) {
      return matchCase(word, lower.slice(0, -1));
    }

    return word;
  }

  function matchCase(original, replacement) {
    return original[0] === original[0].toUpperCase()
      ? replacement.charAt(0).toUpperCase() + replacement.slice(1)
      : replacement;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {activityLog !== null && (
        <MDBox pt={3} pb={3}>
          <MDBox>
            <Button
              color="dark"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate(`/ops/activities/logs`);
              }}
            >
              Back
            </Button>
          </MDBox>
          <MDBox mt={1}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <Card>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Activity Log
                        </MDTypography>
                        <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                          <Icon color="success">edit_note</Icon>
                        </MDBox>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDBox>
                          <Table aria-label="campaign information">
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Activity
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {activityLog.activity.title}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    {singularize(activityLog.entity.relationship)}
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {activityLog.entity.title}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Date
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {activityLog.created}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card>
                    <MDBox mb={3}>
                      <MDBox p={2}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                            Agent Details
                          </MDTypography>
                          <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                            <Icon color="warning">support_agent</Icon>
                          </MDBox>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDBox>
                            <Table>
                              <TableBody>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Name
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {activityLog.agent.title}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Group
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {activityLog.entity.group}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={5}>
            <DataFormSubmissionCard captureRef={ref} data={activityLog.data} />
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default OpsActivityLogPage;
